import { motion } from 'framer-motion';
import { Star, Trophy, Shield, Flame } from 'lucide-react';

const StatCell = ({ icon: Icon, value, label }) => (
  <div className="flex flex-1 flex-col items-center gap-1.5 px-1 py-1">
    <Icon size={18} className="text-brand-500" strokeWidth={2} />
    <p className="text-base font-extrabold tabular-nums leading-none text-surface-900 dark:text-white">
      {value}
    </p>
    <p className="text-[9px] font-bold uppercase tracking-wider text-surface-400 dark:text-[#B5BDD1]">
      {label}
    </p>
  </div>
);

const ProfileStats = ({
  playerRating = 0,
  hostRating = 0,
  safetyRating = 0,
  streak = 0,
}) => {
  const fmt = (n) => (n > 0 ? Number(n).toFixed(1) : '0.0');

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.08, duration: 0.4 }}
      id="profile-ratings-summary"
      className="mt-5 flex items-stretch overflow-hidden rounded-3xl border border-[#E9EEF7] bg-white shadow-[0_2px_20px_rgba(15,23,42,0.04)] dark:border-white/[0.06] dark:bg-[#121826] dark:shadow-none"
    >
      <StatCell icon={Star} value={fmt(playerRating)} label="As Player" />
      <div className="my-4 w-px bg-[#E9EEF7] dark:bg-white/[0.06]" />
      <StatCell icon={Trophy} value={fmt(hostRating)} label="As Host" />
      <div className="my-4 w-px bg-[#E9EEF7] dark:bg-white/[0.06]" />
      <StatCell icon={Shield} value={fmt(safetyRating)} label="Safety" />
      <div className="my-4 w-px bg-[#E9EEF7] dark:bg-white/[0.06]" />
      <StatCell icon={Flame} value={`${streak || 0}d`} label="Streak" />
    </motion.div>
  );
};

export default ProfileStats;
